// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DotLoader__container-e19f93 {
  display: flex;
}

@keyframes DotLoader__blink-f41152 {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
.DotLoader__item-e867f9 {
  width: 5px;
  height: 5px;
  border-radius: 5px;
  margin: 1px;
  background-color: var(--addition-50);
  animation-name: DotLoader__blink-f41152;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}

.DotLoader__item-1-c5b068 {
  animation-delay: 0s;
}

.DotLoader__item-2-df1e45 {
  animation-delay: 0.2s;
}

.DotLoader__item-3-bd0e33 {
  animation-delay: 0.4s;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/DotLoader/DotLoader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE;IACE,YAAA;EACF;EACA;IACE,UAAA;EACF;EACA;IACE,YAAA;EACF;AACF;AAEA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oCAAA;EAEA,uCAAA;EACA,wBAAA;EACA,mCAAA;EACA,yBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,qBAAA;AADF","sourcesContent":[".container {\n  display: flex;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0.2;\n  }\n  20% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.2;\n  }\n}\n\n.item {\n  width: 5px;\n  height: 5px;\n  border-radius: 5px;\n  margin: 1px;\n  background-color: var(--addition-50);\n\n  animation-name: blink;\n  animation-duration: 1.4s;\n  animation-iteration-count: infinite;\n  animation-fill-mode: both;\n}\n\n.item-1 {\n  animation-delay: 0s;\n}\n\n.item-2 {\n  animation-delay: 0.2s;\n}\n\n.item-3 {\n  animation-delay: 0.4s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DotLoader__container-e19f93`,
	"item": `DotLoader__item-e867f9`,
	"blink": `DotLoader__blink-f41152`,
	"item-1": `DotLoader__item-1-c5b068`,
	"item1": `DotLoader__item-1-c5b068`,
	"item-2": `DotLoader__item-2-df1e45`,
	"item2": `DotLoader__item-2-df1e45`,
	"item-3": `DotLoader__item-3-bd0e33`,
	"item3": `DotLoader__item-3-bd0e33`
};
module.exports = ___CSS_LOADER_EXPORT___;
